import axios from 'axios';
import { getToken } from '../utils/jwt-helper';
import { createRequestId } from '../utils/requestId';
import { isHttpTraceEnabled, logAxiosRequestTrace } from './httpTraceLogging';

const axiosClient = axios.create({
  timeout: 15000,
});

axiosClient.interceptors.request.use((config) => {
  const token = getToken();
  const t = token != null ? String(token).trim() : '';

  config.headers = config.headers || {};
  if (!config.headers['X-Request-Id'] && !config.headers['x-request-id']) {
    config.headers['X-Request-Id'] = createRequestId();
  }
  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  } else if ('Authorization' in config.headers) {
    delete config.headers.Authorization;
  }
  return config;
});

axiosClient.interceptors.request.use((config) => {
  logAxiosRequestTrace(config, 'axiosClient');
  return config;
});

axiosClient.interceptors.response.use(
  (res) => {
    const u = res.config?.url || '';
    if (u.includes('/api/file')) {
      const rid = res.config?.headers?.['X-Request-Id'];
      console.info('[axios:upload:ok]', {
        requestId: rid,
        status: res.status,
        serverMs: res.headers?.['x-upload-server-ms'],
      });
    }
    if (isHttpTraceEnabled() && u.includes('/api/file')) {
      console.info('[HTTP_TRACE][axiosClient][res]', {
        url: res.config?.url,
        status: res.status,
        responseHeaders:
          res.headers && typeof res.headers.toJSON === 'function'
            ? res.headers.toJSON()
            : { ...res.headers },
      });
    }
    return res;
  },
  (err) => {
    if (isHttpTraceEnabled()) {
      console.info('[HTTP_TRACE][axiosClient][err]', {
        url: err.config?.url,
        method: err.config?.method,
        code: err.code,
        message: err.message,
        status: err.response?.status,
        responseHeaders: err.response?.headers,
        responseData: err.response?.data,
      });
    }
    console.error('[axios:response:error]', {
      url: err.config?.url,
      requestId: err.config?.headers?.['X-Request-Id'],
      code: err.code,
      message: err.message,
      status: err.response?.status,
    });
    return Promise.reject(err);
  }
);

export default axiosClient;
